export default {
  fragrance: {
    en: 'Fragrance',
  },
  skincare: {
    en: 'Skincare',
  },
  makeup: {
    en: 'Makeup',
  },
  subscribeFor: {
    en: 'Subscribe for just {subscriptionPrice} / month',
  },
  howTo: {
    en: 'How It Works',
  },
  createProfile: {
    en: 'Create a Profile',
  },
  help: {
    en: 'Help',
  },
  recommendations: {
    en: 'Recommendations',
  },
  aboutScentbird: {
    en: 'About Scentbird',
  },
  logIn: {
    en: 'Log in',
  },
  join: {
    en: `<span>Join our Instagram community</span><br />114 000 followers`,
  },
}
